// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.airportDetails,
.searchbar-search-icon {
  top: 4px !important;
  left: 12px !important;
  width: 16px !important;
  height: 18px !important;
}

.smallPara {
  font-size: 11px;
}

.segment-button {
  font-weight: normal;
}

.Legitem {
  min-height: 3.2rem;
  font-size: 11px;
}

.capsLeg {
  font-size: 20px;
}

.smallLeg {
  font-size: 10px;
}

.paraInfo {
  font-size: 14px;
}

.segmentview .segment ion-segment-button.segment-button {
  flex: 1 0 95px;
  height: 5rem;
  line-height: 5rem;
  text-transform: none;
}

.segment-card {
  margin-left: 0;
  margin-top: 0;
}

.mapview {
  border-bottom: none !important;
}

.mapview.activated,
.mapview-activated {
  border-bottom: none !important;
}

.list ion-item {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}
.list ion-label {
  margin: 0px !important;
}
.list h2 {
  font-weight: 500;
}
.list p {
  color: #727272 !important;
  font-size: 12px;
}

.item-list {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.location-right {
  float: right !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/airportdetailscard/airportdetailscard.component.scss"],"names":[],"mappings":"AAAA;;EAEE,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EAIE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,cAAA;EACA,aAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;;EAEE,8BAAA;AACF;;AAGE;EACE,8BAAA;EACA,2BAAA;AAAJ;AAGE;EACE,sBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,eAAA;AAHJ;;AAOA;EACE,8BAAA;EACA,2BAAA;AAJF;;AAMA;EACE,uBAAA;AAHF","sourcesContent":[".airportDetails,\n.searchbar-search-icon {\n  top: 4px !important;\n  left: 12px !important;\n  width: 16px !important;\n  height: 18px !important;\n}\n\n.smallPara {\n  font-size: 11px;\n}\n\n.segment-button {\n  font-weight: normal;\n}\n\n.Legitem {\n  min-height: 3.2rem;\n  font-size: 11px;\n}\n\n.capsLeg {\n  font-size: 20px;\n}\n\n.smallLeg {\n  font-size: 10px;\n}\n\n.paraInfo {\n  font-size: 14px;\n}\n\n.segmentview .segment ion-segment-button.segment-button {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1 0 95px;\n  -ms-flex: 1 0 95px;\n  flex: 1 0 95px;\n  height: 5rem;\n  line-height: 5rem;\n  text-transform: none;\n}\n\n.segment-card {\n  margin-left: 0;\n  margin-top: 0;\n}\n\n.mapview {\n  border-bottom: none !important;\n}\n\n.mapview.activated,\n.mapview-activated {\n  border-bottom: none !important;\n}\n\n.list {\n  ion-item {\n    padding-bottom: 0px !important;\n    padding-top: 0px !important;\n  }\n\n  ion-label {\n    margin: 0px !important;\n  }\n\n  h2 {\n    font-weight: 500;\n  }\n\n  p {\n    color: #727272 !important;\n    font-size: 12px;\n  }\n}\n\n.item-list {\n  padding-bottom: 0px !important;\n  padding-top: 0px !important;\n}\n.location-right {\n  float: right !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
